import React, {useState} from 'react';
import {Link, useHistory} from 'react-router-dom';

import {DataTable} from '../components/DataTable';
import {LoadingIndicator} from '../components/LoadingIndicator';
import {initialFormState, WorkflowSearchForm} from '../components/WorkflowSearchForm';
import {Paginator} from '../components/Paginator';

import {getSearchFilters} from '../_helpers/search';
import {cellRenderers} from '../_helpers/datatable-cellrenderers';
import {User} from '../_services/User';
import {useSearch} from '../_hooks/useSearch';

type MyRequestsPageProps = {};

const initialSearchFilters = {
    show_step_assignees: User.getInstance().getShowStepAssigneesFilter()
}

export const MyRequests: React.FunctionComponent<MyRequestsPageProps> = ({}) => {
    const history = useHistory();
    const {
        isSearching,
        searchResults,
        searchErrorMessage,
        searchFilters,
        setSearchFilters,
        changePage
    } = useSearch(true, initialSearchFilters);

    const [searchFormState, setSearchFormState] = useState<any>({...initialFormState});
    const [showStepAssignees, _setShowStepAssignees] = useState<boolean>(User.getInstance().getShowStepAssigneesFilter());
    const setShowStepAssignees = (state: boolean) => {
        _setShowStepAssignees(state);
        setSearchFilters({
            ...searchFilters,
            show_step_assignees: state
        });
        User.getInstance().setShowStepAssigneesFilter(state);
    };

    return (
        <div>
            <h1 className={'abb-header'}>My Requests</h1>

            <p>This page lists all workflows <strong>initiated</strong> by you. For a list of workflows <strong>assigned</strong> to you, go to your <Link to="/inbox">Inbox</Link></p>

            <WorkflowSearchForm
                onSearch={(formValues: any) => {
                    const searchFilters = Object.keys(formValues).reduce(getSearchFilters(formValues), {});
                    setSearchFilters({...searchFilters, page: 1});
                }}
                formState={searchFormState}
                setFormState={setSearchFormState}
            />

            {searchErrorMessage && <p className="alert alert-danger">{searchErrorMessage}</p>}
            {isSearching && <LoadingIndicator/>}

            {searchResults.entries &&
                <div>
                    <div className="form-check text-right mt-2">
                        <label className="form-check-label pr-4" htmlFor="search-show-step-assignees">
                            Show Step Assignees?
                        </label>
                        <input type="checkbox"
                               className="form-check-input"
                               id="search-show-step-assignees"
                               value="Y"
                               checked={showStepAssignees}
                               onChange={(e) => {
                                   setShowStepAssignees(e.target.checked);
                               }}
                        />
                    </div>

                    <DataTable
                        id="search-table"
                        striped={true}
                        classNames="table-borderless"
                        headings={searchResults.columns}
                        rows={searchResults.entries}
                        onRowClick={(row: any) => {
                            history.push('/entry/' + row.id);
                        }}
                        cellRenderers={cellRenderers}
                    >
                        <Paginator
                            currentPage={searchResults.page}
                            rowsPerPage={searchResults.page_size}
                            numberOfPages={searchResults.page_count}
                            numberOfRecords={searchResults.total_count}
                            onChange={(page: number, recordsPerPage: number) => changePage(page, recordsPerPage)}
                        />
                    </DataTable>
                </div>
            }
        </div>
    );
};
